/*******************************************************************************
RUN A FUNCTION WHEN THE WINDOW IS RESIZED
Triggers a function when the window is resized.
*******************************************************************************/

export default function doOnWindowResize(functionToRun) {
    $(window).on('rw:window-resized', functionToRun);
}
